import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers/RootReducer';

// The store is the central place where the state of your application is managed.
// It holds the entire state tree of your application and allows you to dispatch actions to update the state.

const store = configureStore({
  reducer: rootReducer, // The rootReducer combines all the individual reducers into a single reducer function.
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk), // Adding thunk middleware to handle asynchronous actions.
});

// This store configuration is useful because it sets up the Redux store with the root reducer and middleware.
// The thunk middleware allows you to write action creators that return a function instead of an action, enabling asynchronous logic.

// Thunk middleware is particularly useful for handling complex synchronous logic and side effects, such as API calls.
// It allows you to delay the dispatch of an action or to dispatch only if a certain condition is met.
// With thunk, you can access the store's dispatch and getState methods, making it easier to coordinate actions and state updates.

export default store;